// extracted by mini-css-extract-plugin
export default {"text-orange":"DeleteExpense_text-orange__M3Ts-","text-center":"DeleteExpense_text-center__dT8Ki"};